<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="待审核"></el-radio-button>
            <el-radio-button label="已审核"></el-radio-button>
            <el-radio-button label="审核失败"></el-radio-button>
        </el-radio-group>
    </div>
    <div class='titleInfoBox'>
        <el-input style="width: 300px" v-model="phone" placeholder="请输入用户手机号码进行查询" clearable><el-button slot="append" icon="el-icon-search" @click="saveSearch"></el-button></el-input>
      <el-input style="width: 300px" v-model="name" placeholder="请输入用户真实姓名进行查询" clearable><el-button slot="append" icon="el-icon-search" @click="saveSearch"></el-button></el-input>
      <el-input style="width: 300px" v-model="nickname" placeholder="请输入用户昵称进行查询" clearable><el-button slot="append" icon="el-icon-search" @click="saveSearch"></el-button></el-input>

    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.name}}，{{item.phone}}，所在地：{{item.cityName}}，自我定位：{{item.currentStatus}},来源：{{item.source}}</P>
                <p>
                    专注行业：{{item.industry}}，专注职能：{{item.jobType}},专注地区：{{item.currentAdder}},{{item.createTime}}
                </p>
                <p>
                    年薪：{{item.yearSalary}}W，上年度成单金额：{{item.lastYearMoney}}W
                </p>
                <p>
                    备注：{{item.des}}
                </p>
                <p>
                    用户id：{{item.userId}}
                </p>
            </div>
            <div class="rightDiv">
                <div>
                    <el-button v-if="selectTypeArray[selectType] === 0" @click="set1(item,1)">通过审核</el-button>
                    <el-button v-if="selectTypeArray[selectType] === 0" @click="set2(item,2)">审核失败</el-button>
                    <el-button @click="set3(item)">备注</el-button>
                </div>
            </div>
        </div>
    </div>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="shsbInfoStatus1" width="30%" center>
        <p style="padding:10px 0">是否将该申请设置为通过</p>
          <el-radio v-model="roleLevle" label="1">顾问</el-radio>
          <el-radio v-model="roleLevle" label="3">合伙人</el-radio>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="shsbInfoStatus1 = false">取 消</el-button>
            <el-button type="primary" @click="qr(1)">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="shsbInfoStatus2" width="30%" center>
        <p style="padding:10px 0">是否将该申请设置为未通过</p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="shsbInfoStatus2 = false">取 消</el-button>
            <el-button type="primary" @click="qr(2)">确 定</el-button>
        </span>
    </el-dialog>
        <el-dialog title="提示" :visible.sync="shsbInfoStatus3" width="30%" center>
        <p style="padding:10px 0">备注</p>
        <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="setItem.des">
        </el-input>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="shsbInfoStatus3 = false">取 消</el-button>
            <el-button type="primary" @click="bz()">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'authApply',
    props: {},
    data() {
        return {
            roleLevle: "1",
            shsbInfoStatus1: false,
            shsbInfoStatus2: false,
            shsbInfoStatus3: false,
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            id: '',
            dialogVisible: false,
            setid: '',
            setItem: {},
            setPdfUrl: '',
            setnum: '',
            selectType: '待审核',
            selectTypeArray: {
                "待审核": 0,
                "已审核": 1,
                "审核失败": 2
            },
            monthlyPay: 0,
            moneyReward: 0,
            entryDate: '',
            commissionMethod: false,
            homeAmount: 0,
            warrantyAmount: 0,
            jobInfo: {

            },
            tdrInfo: {},
            tdrInfoStatus: false,
            reasShBox: false,
            shsbInfoStatus: false,
            setShsbItem: {
                sbyyInfo: ''
            },
            name: '',
            phone: '',
            nickname: ''
        }
    },
    watch: {

    },
    methods: {
        getPositionLost: function () {
            let that = this
            let data = {
                pageSize: this.pageSize,
                pageNum: this.pageNumber,
                verifyStatus: this.selectTypeArray[this.selectType]
            }
            if (this.name !== '') {
                data.name = this.name
            }
             if (this.phone !== '') {
                data.phone = this.phone
            }
            if (this.nickname !== '') {
                data.nickname = this.nickname
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/apply/getAuthList',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    for (let i in demo) {
                        if (demo[i].des === undefined || demo[i].des === '') {
                            demo[i].des = ''
                        }
                    }
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },

        qr (flag) {
            let that = this
            let data = {verifyStatus: flag,
                    id: this.setItem.id}
                    if (flag === 1) {
                        data.roleLevle = this.roleLevle
                    }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/apply/authApply',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.shsbInfoStatus1 = false
                    that.shsbInfoStatus2 = false
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        bz () {
            let that = this
            let data = {des: this.setItem.des,
                    id: this.setItem.id}
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/apply/authApplyDsc',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.shsbInfoStatus1 = false
                    that.shsbInfoStatus2 = false
                    that.shsbInfoStatus3 = false
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        onChangeSelectType(e) {
            this.pageSize = 20
            this.pageNumber = 1
            this.selectType = e
            this.getPositionLost()
        },
        set1 (item) {
            this.setItem = item
            this.shsbInfoStatus1 = true
        },
        set2 (item) {
            this.setItem = item
            this.shsbInfoStatus2 = true
        },
        set3 (item) {
            this.setItem = item
            this.shsbInfoStatus3 = true
        },
        saveSearch: function () {
            this.pageNumber = 1
            this.getPositionLost()
        }
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv .active {
    color: red;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}

.demo-input-suffix>p {
    padding: 10px 0;
}

.reasShBox {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.reasShBox>div {
    width: 50vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
}

.reasShBox>div>iframe {
    width: 100%;
    height: 100%;
}

.reasShBox>div:nth-child(1) {
    background-color: #ffffff;
    padding: 30px;
    box-sizing: border-box;
}

.reasShBox>div .title {
    padding: 10px 0;
    width: max-content;
    background-color: #cecece;
}

.reasShBox>div .cont {
    padding: 10px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}

.reasShBox .buttonBox {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.titleInfoBox{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: max-content;
    margin: 30px auto;
    box-sizing: border-box;
}
</style>
